export const Roles = {
  ADMIN: "Admin",
  USER: "User"
};
